import { ChangeEmail } from "@/features/account/components/change-details/change-email";

const EmailDetails = () => {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <h1 className="mb-4 text-2xl font-semibold">
                    Change your email
                </h1>
                <ChangeEmail />
            </div>
        </div>
    );
};

export default EmailDetails;
